import request from '@/utils/request';
//获取图形验证码
export function generateCode() {
    return request({
        // url: 'https://youqian.acc5.com/manage/auth/captcha_api',
        url: '/sso/authorize/captcha',
        method: 'get',
    });
}
//登录
export function doLogin(data) {
    return request({
        url: '/sso/authorize/login',
        method: "post",
        data
    });
}
//退出登录
export function doLoginOut(data) {
    return request({
        url: '/sso/authorize/logout',
        method: "post",
        data
    });
}
//获取用户信息
export function getUserInfo(data) {
    return request({
        url: '/sso/authorize/user_info',
        method: "post",
        data
    });
}
//token验证
export function verifyUser(data) {
    return request({
        url: '/sso/authorize/verify',
        method: "post",
        data
    });
}
export function get_login_wx_work(data) {
    return request({
        url: '/sso/authorize/login_code',
        method: "post",
        data
    });
}
export function get_bind_wx_work(data) {
    return request({
        url: '/sso/authorize/bind_code',
        method: "post",
        data
    });
}
export function un_bind_wx_work(data) {
    return request({
        url: '/sso/authorize/unbind',
        method: "post",
        data
    });
}
export function get_bind_weixin(params) {
    return request({
        url: 'https://dc-api.acc5.com/v1/wechat/authorization_qrcode',
        method: 'get',
        params
    });
}
export function un_bind_weixin(data) {
    return request({
        url: 'https://dc-api.acc5.com/v1/wechat/unbind_admin',
        method: "post",
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/user.js